var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { node: true, "node-error-state": _vm.showError } },
    [
      _c(
        "div",
        {
          staticClass: "xxxx",
          class: { "node-body": true, error: _vm.showError },
        },
        [
          _c(
            "div",
            {
              staticClass: "node-body-main",
              on: {
                click: function ($event) {
                  return _vm.$emit("selected")
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "node-body-main-header" },
                [
                  _c("ellipsis", {
                    staticClass: "title",
                    attrs: {
                      "hover-tip": "",
                      content: _vm.config.name
                        ? _vm.config.name
                        : "条件" + _vm.level,
                    },
                  }),
                  _c("span", { staticClass: "level" }, [
                    _vm._v("优先级" + _vm._s(_vm.level)),
                  ]),
                  _vm.$store.state.diagramMode !== "viewer"
                    ? _c("span", { staticClass: "option" }, [
                        _c("i", {
                          staticClass: "el-icon-close",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.$emit("delNode")
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "node-body-main-content" },
                [
                  (_vm.content || "").trim() === ""
                    ? _c("span", { staticClass: "placeholder" }, [
                        _vm._v(
                          _vm._s(
                            _vm.level == _vm.size && _vm.size != 0
                              ? "其他条件进入此流程"
                              : _vm.placeholder
                          )
                        ),
                      ])
                    : _c("ellipsis", {
                        attrs: { hoverTip: "", row: 3, content: _vm.content },
                      }),
                ],
                1
              ),
            ]
          ),
          _vm.showError
            ? _c(
                "div",
                { staticClass: "node-error" },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.errorInfo,
                        placement: "top-start",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-warning-outline" })]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "node-footer" }, [
        _c(
          "div",
          { staticClass: "btn" },
          [
            _vm.$store.state.diagramMode !== "viewer"
              ? _c("insert-button", {
                  on: { insertNode: (type) => _vm.$emit("insertNode", type) },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }